import React from 'react';
import { FiArrowUpRight, FiCalendar } from 'react-icons/fi';
import './Projects.css';

const projects = [
  {
    title: 'Enterprise Network Overhaul',
    description:
      'Transformasi total infrastruktur jaringan enterprise dengan kapasitas 10Gbps, redundansi ganda, dan monitoring real-time untuk perusahaan manufacturing.',
    tags: ['Network', 'Enterprise'],
    date: 'Nov 2024',
  },
  {
    title: 'Government Cloud Migration',
    description:
      'Migrasi data center pemerintahan ke platform hybrid cloud dengan standar keamanan data tertinggi dan compliance regulasi pemerintah.',
    tags: ['Cloud', 'Government'],
    date: 'Sep 2024',
  },
  {
    title: 'Custom SD-WAN Implementation',
    description:
      'Implementasi SD-WAN untuk perusahaan retail dengan 50+ cabang di seluruh Indonesia, mengoptimalkan konektivitas antar lokasi.',
    tags: ['SD-WAN', 'Retail'],
    date: 'Jul 2024',
  },
  {
    title: 'Cyber Defense Center Setup',
    description:
      'Pembangunan Security Operations Center (SOC) lengkap dengan SIEM, threat intelligence, dan incident response team 24/7.',
    tags: ['Security', 'SOC'],
    date: 'May 2024',
  },
];

const Projects = () => {
  return (
    <section className="projects section" id="proyek">
      <div className="container">
        <div className="projects__header">
          <span className="section-label">Featured Projects</span>
          <h2 className="section-title">Solusi Nyata untuk Tantangan Kompleks</h2>
          <p className="section-subtitle">
            Eksplorasi bagaimana kami membantu perusahaan berskala besar mengatasi tantangan 
            infrastruktur IT dengan solusi inovatif.
          </p>
        </div>

        <div className="projects__grid">
          {projects.map((project, index) => (
            <div key={index} className="projects__card">
              <div className="projects__card-image"></div>
              <div className="projects__card-content">
                <div className="projects__card-meta">
                  <FiCalendar size={12} />
                  <span>{project.date}</span>
                </div>
                <h3 className="projects__card-title">
                  {project.title}
                  <FiArrowUpRight size={16} className="projects__card-arrow" />
                </h3>
                <p className="projects__card-description">{project.description}</p>
                <div className="projects__card-tags">
                  {project.tags.map((tag, i) => (
                    <span key={i} className="projects__card-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
